import type { IconSvgObject } from './types';

const JarIcon: IconSvgObject = [
  ["path", { d: "M18.5 8H15M18.5 11.3366H15M18.5 14.6683H15M18.5 17.9878L15 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.5 9.5V4.00523C3.5 2.89862 4.39861 2.00234 5.50522 2.00523L6.49416 2.00781M6.49416 2.00781H20.3991C20.4794 2.00781 20.5275 2.09665 20.4831 2.16317L18.9297 4.49093C18.7103 4.81962 18.5933 5.20593 18.5933 5.6011V20C18.5933 21.1046 17.6978 22 16.5933 22H8.49416C7.38959 22 6.49416 21.1046 6.49416 20V2.00781Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default JarIcon;
